import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/api/auth';
import { useAuth, useSyncAuthUser } from '@/context/AuthContext';

export function useWelcomeScreen() {
    const { user } = useAuth();
    const syncAuthUser = useSyncAuthUser();

    const completeWelcomeMutation = useMutation({
        mutationFn: authApi.completeWelcomeScreen,
        onSuccess: (completion) => syncAuthUser(completion),
    });

    return {
        hasCompletedWelcome: user?.welcome_screen_completed === true,
        welcomeCompletedAt: user?.welcome_screen_completed_at ?? null,
        completeWelcome: completeWelcomeMutation.mutateAsync,
        isCompletingWelcome: completeWelcomeMutation.isPending,
    };
}
